import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ToastService } from "./toast.service";

@Injectable()
export class ContactService {
  private base_url = `${environment.API_URL}/contacts`;
  private single_url = `${environment.API_URL}/contact`;
  private token = localStorage.getItem("token");
  private headers = new HttpHeaders().set("Authorization", `${this.token}`);

  constructor(private http: HttpClient, private toast: ToastService) {}

  getContacts(params) {
    return this.http
      .post(this.base_url, params, { headers: this.headers })
      .map((res) => JSON.parse(JSON.stringify(res)));
  }

  createContact(params) {
    return this.http
      .post(this.single_url, params, { headers: this.headers })
      .map((res) => {
        let response = JSON.parse(JSON.stringify(res));
        if (response === 200) {
          this.toast.success("Contact Ajouté avec succès.", false, "Contact");
        } else {
          this.toast.error(
            "Erreur lors de l'ajout du Contact.",
            false,
            "Contact"
          );
        }
      });
  }

  updateContact(contact_id, params) {
    return this.http
      .patch(`${this.single_url}/${contact_id}?token=${this.token}`, params, {
        headers: this.headers,
      })
      .map((res) => {
        let response = JSON.parse(JSON.stringify(res));
        if (response === 200) {
          this.toast.success(
            "Contact Mis à jour avec succès.",
            false,
            "Contact"
          );
        } else {
          this.toast.error(
            "Erreur lors de la mise à jour du Contact.",
            false,
            "Contact"
          );
        }
      });
  }

  deleteContact(contact_id) {
    return this.http
      .delete(`${this.single_url}/${contact_id}?token=${this.token}`, {
        headers: this.headers,
      })
      .map((res) => {
        let response = JSON.parse(JSON.stringify(res));
        if (response === 200) {
          this.toast.success("Contact Supprimé avec succès.", false, "Contact");
        } else {
          this.toast.error(
            "Erreur lors de la suppression du Contact.",
            false,
            "Contact"
          );
        }
      });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_services/contact.service.ts